enum ActionTypes {
  PRODUCTS_SOURCE_REQUEST = 'app/LandingPage/FarmToTable/PRODUCTS_SOURCE_REQUEST',
  PRODUCTS_SOURCE_SUCCESS = 'app/LandingPage/FarmToTable/PRODUCTS_SOURCE_SUCCESS',
  PRODUCTS_SOURCE_FAILURE = 'app/LandingPage/FarmToTable/PRODUCTS_SOURCE_FAILURE',
  PRODUCTS_SOURCE_FAVORITE = 'app/LandingPage/FarmToTable/PRODUCTS_SOURCE_FAVORITE',
  PRODUCTS_SOURCE_FAVORITE_REQUEST = 'app/LandingPage/FarmToTable/PRODUCTS_SOURCE_FAVORITE_REQUEST',
  PRODUCTS_SOURCE_FAVORITE_SUCCESS = 'app/LandingPage/FarmToTable/PRODUCTS_SOURCE_FAVORITE_SUCCESS',
  PRODUCTS_SOURCE_FAVORITE_FAILURE = 'app/LandingPage/FarmToTable/PRODUCTS_SOURCE_FAVORITE_FAILURE',
  SET_PRODUCT_NOTE = 'app/LandingPage/FarmToTable/SET_PRODUCT_NOTE',
  SET_PRODUCT_NOTE_REQUEST = 'app/LandingPage/FarmToTable/SET_PRODUCT_NOTE_REQUEST',
  SET_PRODUCT_NOTE_SUCCESS = 'app/LandingPage/FarmToTable/SET_PRODUCT_NOTE_SUCCESS',
  SET_PRODUCT_NOTE_FAILURE = 'app/LandingPage/FarmToTable/SET_PRODUCT_NOTE_FAILURE',
  GET_MORE_SECTION_DATA = 'app/LandingPage/FarmToTable/GET_MORE_SECTION_DATA',
  PRODUCTS_SOURCE_INIT='app/LandingPage/FarmToTable/PRODUCTS_SOURCE_INIT',
  CHECK_EMAIL_SUBMIT = 'app/LandingPage/FarmToTable/CHECK_EMAIL_SUBMIT',
  CHECK_EMAIL_REQUEST = 'app/LandingPage/FarmToTable/CHECK_EMAIL_REQUEST',
  CHECK_EMAIL_SUCCESS = 'app/LandingPage/FarmToTable/CHECK_EMAIL_SUCCESS',
  CHECK_EMAIL_FAILURE = 'app/LandingPage/FarmToTable/CHECK_EMAIL_FAILURE',
  CONTACT_US_SUBMIT = 'app/LandingPage/FarmToTable/CONTACT_US_SUBMIT',
  CONTACT_US_REQUEST = 'app/LandingPage/FarmToTable/CONTACT_US_REQUEST',
  CONTACT_US_SUCCESS = 'app/LandingPage/FarmToTable/CONTACT_US_SUCCESS',
  CONTACT_US_FAILURE = 'app/LandingPage/FarmToTable/CONTACT_US_FAILURE',
  CONTACT_US_SHORT_FORM_REQUEST = 'app/LandingPage/FarmToTable/CONTACT_US_SHORT_FORM_REQUEST',
}

export default ActionTypes;
